import React, { useEffect } from 'react';
import useSiteBranding from '../hooks/useSiteBranding';
import TrustSupportBanner from '../components/TrustSupportBanner';
import './TrustPages.css';

const DEFAULT_TITLE = 'About Us';

export default function AboutPage() {
  const { siteName, siteLogoUrl } = useSiteBranding();
  const brand = siteName || 'Super Wear';

  useEffect(() => {
    document.title = `${DEFAULT_TITLE} — ${brand}`;
  }, [brand]);

  return (
    <div className="trust-page">
      <div className="trust-page__inner trust-page__inner--wide">
        <header className="trust-page__hero trust-page__hero--about">
          <p className="trust-page__hero-eyebrow">Our story</p>
          <h1 className="trust-page__title">About {brand}</h1>
          <p className="trust-page__subtitle">
            Contemporary fashion for everyday confidence — curated with care, priced fairly, delivered with pride across Pakistan.
          </p>
        </header>

        {siteLogoUrl ? (
          <div className="trust-page__logo-wrap">
            <img
              src={siteLogoUrl}
              alt={`${brand} logo`}
              className="trust-page__logo-mark"
            />
          </div>
        ) : null}

        <TrustSupportBanner />

        <section className="trust-section">
          <h2>Who we are</h2>
          <p>
            <strong>{brand}</strong> is a fashion clothing brand built for people who want quality fabrics, on-trend
            silhouettes, and honest value. From everyday essentials to statement pieces, we focus on wearability,
            finishing, and details that feel premium — without the premium-only price tag.
          </p>
        </section>

        <section className="trust-section">
          <h2>Our mission</h2>
          <p>
            We are committed to <strong>quality</strong>, <strong>affordability</strong>, and <strong>style</strong> in
            every product we offer. That means thoughtful sourcing, consistent fits, clear product information, and
            service that respects your time and trust.
          </p>
        </section>

        <section className="trust-section">
          <h2>Our vision</h2>
          <p>
            To become one of Pakistan&apos;s most <strong>trusted clothing brands</strong> — known for reliable quality,
            transparent policies, and a shopping experience that feels effortless on the web and in your wardrobe.
          </p>
        </section>

        <section className="trust-section">
          <h2>Always here for you</h2>
          <p>
            Whether you&apos;re browsing at midnight or need help on a holiday, <strong>{brand}</strong> keeps{' '}
            <strong>online ordering and customer support open 24/7</strong>. Place your order when it suits you — our team
            is available around the clock for questions, order updates, and after-sales care.
          </p>
        </section>

        <section className="trust-section">
          <h2>How we started</h2>
          <p>
            {brand} began with a simple idea: bring runway-inspired looks and dependable staples to your door, with a
            customer-first mindset. We listen to feedback, refine our collections, and invest in the experience — from
            browsing to checkout to after-sales support — so you can shop with confidence.
          </p>
        </section>
      </div>
    </div>
  );
}
